<template>
  <section class="content-padding">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
          <div class="card">
            <div class="card-header">
              <template v-if="!completed">
                <h3 class="mb-1">
                  <label>{{ $t('message.operation_feedback.title') }}</label>
                </h3>
                <label> 1 = <span>{{ $t('message.operation_feedback.level01') }}</span> 5 = {{ $t('message.operation_feedback.level05') }}</label>
              </template>
            </div>
            <div class="card-body">
              <div v-if="loading">
                <loader></loader>
              </div>
              <div v-else-if="!completed">
                <form @submit.prevent="submitFeedback">
                  <div class="card" v-for="topic in topics" :key="topic">
                    <div class="card-header">
                      <label>{{ $t(`message.operation_feedback.${topic}`) }}</label>
                    </div>
                    <div class="card-body score">
                      {{ $t('message.operation_feedback.level01') }}
                      <label class="radio-inline">
                        <input type="radio" value="1" v-model="submitData[topic]" :name="`${topic}_rating`"> 1
                      </label>
                      <label class="radio-inline">
                        <input type="radio" value="2" v-model="submitData[topic]" :name="`${topic}_rating`"> 2
                      </label>
                      <label class="radio-inline">
                        <input type="radio" value="3" v-model="submitData[topic]" :name="`${topic}_rating`"> 3
                      </label>
                      <label class="radio-inline">
                        <input type="radio" value="4" v-model="submitData[topic]" :name="`${topic}_rating`"> 4
                      </label>
                      <label class="radio-inline">
                        <input type="radio" value="5" v-model="submitData[topic]" :name="`${topic}_rating`" required> 5
                      </label>
                      {{ $t('message.operation_feedback.level05') }}
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">
                      <label>{{ $t('message.operation_feedback.suggestion') }}</label>
                    </div>
                    <div class="card-body">
                      <textarea class="form-control" rows="3" v-model="submitData.suggestion"></textarea>
                    </div>
                  </div>
                  <div style="margin-top:0.5em;">
                    <small class="fa-pull-left mt-3 text-muted">FMOR-01-00</small>
                    <button class="btn btn-success fa-pull-right">{{ $t('message.button.submit') }}</button>
                  </div>
                </form>
              </div>
              <div v-else align="center">
                <h3>
                  <label>{{ $t('message.operation_feedback.done') }}</label>
                  <div>
                    <img src="/static/img/mingcute_emoji-line.svg" alt width="90" >
                  </div> 
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import Loader from '../loader/Loader'
import StarRating from 'vue-star-rating'

export default {
  components: {
    Loader,
    StarRating
  },
  data () {
    return {
      rating: 0,
      comment: '',
      completed: false,
      reportProblem: '',
      reportProblemId: '',
      loading: false,
      saving: false,
      topics: [
        'convenience',
        'speed',
        'language',
        'completeness',
        'overall_satisfaction'
      ],
      submitData: {
        convenience: '',
        speed: '',
        language: '',
        completeness: '',
        overall_satisfaction: '',
        suggestion: ''
      }
    }
  },
  methods: {
    async submitFeedback () {
      const { data } = await axios.put(`/operation-professional-feedbacks/${this.feedbackId}`, this.submitData)
      if (!data.error) {
        this.completed = true
      }
    },
    async getFeedbackData () {
      this.loading = true
      this.feedbackId = this.$route.query.id
      if (!this.feedbackId) {
        await this.$swal('Error', this.$i18n.t('message.operation_feedback.error'), 'error')
        this.$router.push('/')
        return
      }
      try {
        const { data } = await axios.get(`/operation-professional-feedbacks/${this.feedbackId}`)
        if (!data.error) {
          this.feedback = data.feedback
          if (this.feedback.status === 1) {
            this.completed = true
          }
        }
        this.loading = false
      } catch (error) {
        await this.$swal('Error', error.message, 'error')
        this.$router.push('/')
      }
    }
  },
  created () {
    this.getFeedbackData()
  }
}
</script>
<style lang="scss" scoped>
.score {
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/feedback/ProfessionalFeedback.vue